import * as React from "react";
import AuthGate from "./AuthGate";
import References from "../features/references/components/References";
import DraftMode from "./DraftMode";
import AppModeToggle, { AppMode } from "./AppModeToggle";
import { JyloDocumentDetector } from "../utils/jyloDocumentDetector";

const App = () => {
  const [mode, setMode] = React.useState<AppMode>("draft");
  const [isAssembly, setIsAssembly] = React.useState(false);

  React.useEffect(() => {
    JyloDocumentDetector.isJyloDocument().then((result) => {
      if (result.isJylo && result.assemblyObjectIdentifier) {
        setIsAssembly(true);
        setMode("references");
      }
    });
  }, []);

  const modeToggle = <AppModeToggle mode={mode} onChange={setMode} isAssembly={isAssembly} />;

  return (
    <AuthGate>
      {mode === "references" ? (
        <References headerLeft={modeToggle} />
      ) : (
        <DraftMode headerLeft={modeToggle} />
      )}
    </AuthGate>
  );
};

export default App;
